import styled from 'styled-components'

export const ConnectorContainer = styled.div`
  height: 2px;
  width: 25rem;
  background: #21976E;
`
